// @ts-nocheck a4b8aa29
import createSingleServiceWidget from './createSingleServiceWidget';
import { isResponsiveEditor } from '@wix/santa-editor-utils';
export default ({ editorAPI }) =>
  createSingleServiceWidget({
    editorAPI,
    isEditorX: isResponsiveEditor(),
  });
